define([
    "language/resource",
    "authui/iamUtils",
    "base/utils/utility",
], function (i18n, iamUtils, util) {
    "use strict";
    /** 
     * type 1: 隐私协议更新
     * type 2: 用户协议更新
     * type 3: 都更新
     * */
    let type = iamUtils.getUrlParams()['type'];
    // 参数异常情况，默认为隐私协议
    if (!['1', '2', '3'].includes(type)) {
      type = '1';
    }

    // 改为用xdomain_type判断是否国际站用户，不再通ip判断
    let xdomainType = iamUtils.getUrlParams()['xdomain_type'] || '';
    let domainType;
    if (xdomainType.toUpperCase() === 'HWC_HK') {
      domainType = 'HK';   // 国际站用户
    } else if (xdomainType.toUpperCase() === 'HWC_EU'){
      domainType = 'EU';   // 欧洲站用户
    } else {
      domainType = 'HWS';  // 国内站用户
    }

    function privacyUpdateCtrl($scope, $sce){
       $scope.i18n = i18n;
       $scope.model = {
            isHWSDomain: domainType === 'HWS',
            privacyPolicyUpdate: i18n("privacyPolicyUpdate"),
            privacyTipPre: i18n("privacyTipPre"),
            privacyTipSuf: i18n("privacyTipSuf"),
            secretprotect: i18n("secretprotect"),
            btnTxtOK: i18n("agreementBtnTxt"),
            btnTxtCancel: i18n("btnTxtCancel"),
            checked: true,
            disable: false,
            privacyAgreement: window.replaceDomain("https://www.huaweicloud.com/declaration/sa_prp_current.html"),
            // 国内站新版条款更新文案
            policyTitle: "",
            policyTip: "",
            chkChange: function () {
                if (this.checked) {
                    $scope.model.disable = false;
                }
                else {
                    $scope.model.disable = true;
                }
            },
        };

        const policyChangeDetail = window.replaceDomain("https://www.huaweicloud.com/declaration/sa_cua_computing_cd.html");
        const privacyAgreement = window.replaceDomain("https://www.huaweicloud.com/declaration/sa_prp.html");
        const userAgreement = window.replaceDomain("https://www.huaweicloud.com/declaration/sa_cua_computing.html");

        const policyI18nMap = {
          1: {
            policyTitle: i18n('privacyUpdateTitle'),
            policyTip: $sce.trustAsHtml(iamUtils.i18nFormat(i18n('privacyTip'), policyChangeDetail, privacyAgreement))
          },
          2: {
            policyTitle: i18n('agreementUpdateTitle'),
            policyTip: $sce.trustAsHtml(iamUtils.i18nFormat(i18n('agreementTip'), policyChangeDetail, userAgreement))
          },
          3: {
            policyTitle: i18n('agreementAndPrivacyUpdateTitle'),
            policyTip: $sce.trustAsHtml(iamUtils.i18nFormat(i18n('agreementAndPrivacyTip'), policyChangeDetail, userAgreement, privacyAgreement))
          }
        };

        $scope.model.policyTitle = policyI18nMap[type].policyTitle;
        $scope.model.policyTip = policyI18nMap[type].policyTip;

        $(document).keydown(function (event) {
            if(event.keyCode === 13){
                if ( $scope.model.disable === false ) {
                    $scope.onSubmitClick();
                }
            }
        });
        $scope.onSubmitClick = function(){
            onSubmitClick($scope);
        };
        $scope.onCancelClick = function(){
            var service = util.getUrlParams().service;
            var redirectUrl = window.replaceDomain("https://id1.cloud.huawei.com/AMW/logout");
            service !== undefined ? service = `https://${window.LOGIN_CONFIG.AUTH_DOMAIN}/authui/logout?service=` + service : service = `https://${window.LOGIN_CONFIG.AUTH_DOMAIN}/authui/logout`;
            window.location.href = redirectUrl + "?service=" + service;
        };
    };
    function onSubmitClick($scope){
        if (window.productType === "HWS" && $scope.model.disable) {
            iamUtils.MESSAGE.ERROR(i18n("privacyAgreementNotAcceptedError"), "", "popupMsg");
        } else {
            var temp = document.createElement("form");
            temp.action = iamUtils.getUrlParams()['isFromID'] == '1' ? "/authui/signPrivateAggreement" : '/authui/validateUser';
            if(window.location.search !== ""){
                temp.action = temp.action + "?" + window.location.search.substring(1,window.location.search.length);
            }
            temp.method = "post";
            temp.style.display = "none";
            var step = document.createElement("textarea");
            step.name = "step";
            step.value = "afterPrivatePolicy";
            temp.appendChild(step);
            var signType = document.createElement("textarea");
            signType.name = "sign_type";
            signType.value = type;
            temp.appendChild(signType);
            // 统一ID兼容
            if(iamUtils.getUrlParams()['isFromID']){
                var opt = document.createElement("textarea");
                opt.name = "isFromID";
                opt.value = iamUtils.getUrlParams()['isFromID'];
                temp.appendChild(opt);
            }
            document.body.appendChild(temp);
            temp.submit();
        }
    }
    return privacyUpdateCtrl;
});



// WEBPACK FOOTER //
// ./public/base/js/privacyUpdate/controllers/privacyUpdateController.js